export const EXPERIMENT_USA_UNLIMITED_OFFER = 'usa-unlimited-offer';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_CONTROL = 'control';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_ONLY =
  'unlim-only';
export const EXPERIMENT_USA_UNLIMITED_OFFER_VARIANT_UNLIMITED_PLUS =
  'unlim-19-plus-12';
export const EXPERIMENT_UPSELL_SURVEY = 'upsell_survey';
export const EXPERIMENT_INBOX = 'inbox-received-transfers';
export const EXPERIMENT_SEND_FEEDBACK = 'send-feedback';
export const EXPERIMENT_VIDEO_UPLOADS = 'video-wallpaper-uploads';
export const EXPERIMENT_TRANSFER_OPTIONS_ICON = 'transfer-options-icon';

export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';
